import { HTTP } from "@/utils/http-common"

export default {
  get: function($, tablename) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/extrafields/${tablename}/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  product_distribution: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/extrafields/distribution/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  product_perfumers: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/extrafields/perfumers/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  product_perfume_houses: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/extrafields/perfume_houses/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  product_tags: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/extrafields/tags/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  product_other_olfa_desc: function($) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/perfumist/product/extrafields/other_olfa_desc/`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  }
}
